<template>
  <v-sheet tile color="#ffffff" >
    <v-container>
      <div class="title">Reset your password</div>
      <div>
        <v-form v-model="firstIsValid">
          <div>
            <v-text-field background-color="white" filled light required v-model="username" label="Email"
                          :rules="emailRules" ref="email_field" autofocus name="email"
                          v-on:keyup.enter="submit" @input="resetSend"/>
          </div>
        </v-form>
        <v-form v-model="secondIsValid">
          <div v-if="sent">
            <v-text-field background-color="white" filled light required v-model="code" label="Code" @input="resetError"
                          autocomplete="one-time-code" :rules="[v => !!v || 'Code is required']" ref="code_field" type="numeric" name="code"/>
          </div>
          <div v-if="sent">
            <input style="width:0px;height:0px;position:absolute" />
            <v-text-field filled background-color="white" light required ref="password_field"
                          :rules="[v => !!v || 'New Password is required', v => v.length > 7 || 'Minimum password length is 8 chars']"
                          autocomplete="new-password"
                          :append-icon="show_new_pass? 'visibility' : 'visibility_off'" @input="resetError"
                          :type="show_new_pass? 'text': 'password'" @click:append="show_new_pass = !show_new_pass"
                          v-model="password" label="New password" name="new_password"
                          v-on:keyup.enter="signIn"/>
          </div>
        </v-form>
      </div>
      <div class="error pa-2 white--text rounded" v-if="error">
        {{ error }}
      </div>
      <br/>
      <div class="buttons-container">
        <v-btn v-if="!sent" color="primary" v-on:click="submit" :disabled="!username || !firstIsValid">Send Code</v-btn>
        <v-btn v-if="sent" color="primary" v-on:click="verify" :disabled="!username || !secondIsValid">Submit</v-btn>
        <v-btn v-if="!sent" color="primary" v-on:click="signIn">Back to Sign In</v-btn>
        <v-btn v-if="sent" color="primary" v-on:click="submit">Resend Code</v-btn>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
  import {AmplifyEventBus} from 'aws-amplify-vue';

  export default {
    name: 'ForgotPassword',
    props: ['user'],
    data() {
      return {
        username: this.user.username,
        code: '',
        password: '',
        error: '',
        sent: false,
        show_new_pass: false,
        firstIsValid: false,
        secondIsValid: false
      }
    },
    computed: {
      emailRules()
      {
        return [
              v => !!v || 'Email is required',
              v => (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || 'Email must be valid'
            ]
      }
    },
    methods: {
      resetError: function()
      {
          this.error = ''
      },
      resetSend: function()
      {
        this.sent = false
        this.resetError()
      },
      submit: function () {
        this.$Amplify.Auth.forgotPassword(this.username)
          .then(() => {
            this.sent = true;
          })
          .catch(e => this.setError(e));
      },
      verify: function () {
        this.$Amplify.Auth.forgotPasswordSubmit(this.username, this.code, this.password)
          .then(() => {
            AmplifyEventBus.$emit('authState', 'signedOut');
          })
          .catch(e => this.setError(e));
      },
      signIn: function () {
        AmplifyEventBus.$emit('authState', 'signedOut');
      },
      setError: function (e) {
        this.error = e.message || e;
      }
    }
  }
</script>
<style lang="scss" scoped>
    .buttons-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 1rem;

  }
</style>



// WEBPACK FOOTER //
// src/Auth/ForgotPassword.vue